import { Money } from '@dreryk/money-common-api';

import { getCustomFormattingContext, priceRangeFormatter } from '@dreryk/react-common';
import { InteractiveTable } from '@dreryk/react-components';

type ReceptionServiceInteractiveTablePriceRangeCellProps = {
   readonly minPrice: Money;
   readonly maxPrice: Money;
};

export const ReceptionServiceInteractiveTablePriceRangeCell = (
   props: ReceptionServiceInteractiveTablePriceRangeCellProps
): JSX.Element => {
   return (
      <InteractiveTable.Cell testId={'priceRange'}>
         {priceRangeFormatter(
            {
               min: props.minPrice.asNumber(),
               max: props.maxPrice.asNumber(),
            },
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: true,
               },
            })
         )}
      </InteractiveTable.Cell>
   );
};
